<template>
<div class="flex flex-wrap justify-between">
    <div class="text-14 lg:text-16">
        <div class="text-a-brown-9f8273">{{title}}</div>
        <div class="text-a-brown-502314">{{operateHrs}}</div>
    </div>
    <RedButton @click="Tel()" :customClass="redBtnStyle">
        <div class="text-14 lg:text-16 text-a-brown-f5ebdc" @click="callTel()">{{lbl.contact.call}}
        <span class="tracking-2px">{{tel}}</span></div>
    </RedButton>
</div>
</template>
<script>
//components
import RedButton from "@/components/Button/RedButton.vue";
//mixins
import LocaleMixin from "@/mixin/LocaleMixin";
export default {
    name: "ContactDetail",
    mixins: [LocaleMixin],
    props: {
        title: String,
        operateHrs: String,
        tel: String,
    },
    components: {
        RedButton,
    },
    data: function() {
        return {
            redBtnStyle: 'w-fit h-8 px-3',
        }
    },
    methods: {
        callTel: function(){
            window.location.href = "tel:" + this.tel;
        }
    },

}
</script>
<style lang="scss" scoped>
</style>
